
import _includes from "lodash/includes.js";
import liff from "@line/liff";

export default defineNuxtPlugin(async (nuxtApp) => {

  if(process.client) {
    const route = useRoute();
    let pathParam = route.params.path;
    let pathQuery = route.query.path;

    // eventId from LIFF STATE
    const { search } = window.location;
    const queryString = decodeURIComponent(search).replace("?liff.state=","");
    const params = new URLSearchParams(queryString);
    const paramsString = params.toString();

    if(!paramsString) {
      return
    }

    const splitArr = paramsString?.split("path=")[1];
    const targetPathFromLiff = splitArr?.split("&")[0];

    //save eventId to localstorage
    let thisPath = targetPathFromLiff || pathQuery || pathParam;
    if (thisPath) {
     localStorage.setItem("toPath", thisPath);
    }

    return;
}
});
